<template>
    <div class="w-full h-4/4 place-items-end z-50 fixed bg-red-600 flow-root" v-if="data_alert.open">
        <div class="w-10/12 max-w-sm min-w-50 bg-white border-l-4 text-left p-4 absolute right-0" :class="[data_alert.type === 'success' ? ' border-green-500 text-green-700' : data_alert.type === 'warning' ? ' border-yellow-500 text-yellow-700' : ' border-red-500 text-sirit_blue-700']" role="alert">
            <div class="text-right" @click="closeAlert()">
            <span class="cursor-pointer font-bold " :class="[data_alert.type === 'success' ? 'hover:text-green-400' : data_alert.type === 'warning' ? 'hover:text-orange-400' : 'hover:text-sirit_blue-400' ]">x</span>
            </div>
            <p class="font-bold">{{data_alert.title}}</p>
            <p class="text-md">{{data_alert.msg}}</p>
            <p class="text-md" v-if="data_alert.description !== ''"><span class="font-bold">Detalle:</span>  {{data_alert.description}}</p>
        </div>
    </div>
</template>

<script lang="ts">

export default {
  name: 'Alert',
  props: {
    data_alert: { type: Object, required: true, default() {
    return{
        title: "",
        msg: "",
        description: "",
        type: "",
        open: true
        }
    }}
  },
  emits: ['onFire'],
  setup (props: any, { emit } : any) {

    const closeAlert = () => {
      if(props.data_alert.open == true){
        emit("onFire")
      }
      
    }

    return {
      closeAlert,
    }

  }
}

</script>
